import { render, staticRenderFns } from "./ListLoader.vue?vue&type=template&id=98148462&scoped=true&"
import script from "./ListLoader.vue?vue&type=script&lang=js&"
export * from "./ListLoader.vue?vue&type=script&lang=js&"
import style0 from "./ListLoader.vue?vue&type=style&index=0&id=98148462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98148462",
  null
  
)

export default component.exports